import script from "./Maintain_Leagues.vue?vue&type=script&setup=true&lang=js"
export * from "./Maintain_Leagues.vue?vue&type=script&setup=true&lang=js"

import "./Maintain_Leagues.vue?vue&type=style&index=0&id=226ca977&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-226ca977"]])

export default __exports__